<template>
    <div>
        <asset-navbar :filterMarket="filterMarket" show-boosts>
            <template v-slot:title>Groups</template>
            <template v-slot:subTitle>
            </template>
        </asset-navbar>

        <group-list
            v-if="filterMarket && gotData"
            :groupList="filteredGroups"
            />

        <div v-if="!gotData" class="p-3 text-center">Loading...</div>

        <div v-if="gotData && !filteredGroups.length" class="p-3 text-center">No long buys found</div>
    </div>
</template>

<script>
import apiMixin from '@/mixins/api';
import GroupList from '../components/GroupList.vue';
import AssetNavbar from '../components/AssetNavbar.vue';

export default {
    name: 'Groups',
    mixins: [apiMixin],
    components: {
        GroupList,
        AssetNavbar
    },
    props: ['market', 'assets'],
    data() {
        return {
            groups: [],
            filterMarket: '',
            gotData: false,
        }
    },
    created() {
        this.fetchGroups()
        this.filterMarket = this.market;
    },
    methods: {
        getAssetBySymbol(symbol) {
            return this.$store.getters.getAssetBySymbol(symbol)
        },
        async fetchGroups() {
            this.gotData = false;

            const response = await this.apiGet('/api/groups');
            if (!response) return;

            this.groups = response.data.groups;
            this.gotData = true;
        },
    },
    computed: {
        filteredGroups() {
            return this.groups
                .filter(group => {
                    const asset = this.getAssetBySymbol(group.asset_symbol);
                    return asset && asset.market === this.filterMarket;
                })
                .sort((a, b) => (Math.abs(a.stage_change_time) < Math.abs(b.stage_change_time)) ? 1 : -1);
        },
    },
    watch: {
        $route(to) {
            // (to, from)
            // force content refresh when switching props
            this.filterMarket = to.params.market; 
        }
    }
}
</script>
